import { UITypes } from "types"

import { ScheduledMessageTitleCell } from "./ScheduledMessageTitleCell"

export const customerDashboardMessagesHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Schedule",
    type: "default",
    name: "schedule",
    size: "middle",
    cellComponent: "datetime",
  },
  {
    title: "Message Title",
    type: "default",
    name: "message_title",
    size: "middle",
    cellComponent: ScheduledMessageTitleCell,
  },
]
